import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { AppLayout } from './core'
import './app.scss'
import AzureADWrapper from './core/authentication/azuread-wrapper'

const App = () => {
  const history = createBrowserHistory()
  return (
    <AzureADWrapper>
      <Router history={history}>
        <AppLayout />
      </Router>
    </AzureADWrapper>
  )
}

export default App
